export default "__VITE_PUBLIC_ASSET__b97bf9d8__"